<h2 mat-dialog-title i18n>Copy time configuration</h2>
<mat-dialog-content>
  <div i18n>Apply the time configuration of <span class="font-bold">{{ daysOfTheWeek[data.dayIndex] }}</span> to:</div>
  <ul class="pl-4 mt-4">
    @for (dayOfTheWeek of daysOfTheWeek; let index = $index; track dayOfTheWeek) {
      @if (index !== data.dayIndex) {
        <li class="mb-2">
          <mat-slide-toggle [checked]="dayValues[index]" (toggleChange)="dayValues[index] = !dayValues[index]">
            <ng-container>{{ dayOfTheWeek }}</ng-container>
          </mat-slide-toggle>
        </li>
      }
    }
  </ul>
</mat-dialog-content>
<mat-dialog-actions>
  <button (click)="matDialogRef.close(dayValues)"
          color="primary"
          class="grow-0"
          mat-raised-button
          type="button">
    <ng-container i18n>Submit</ng-container>
  </button>
  <button (click)="matDialogRef.close()"
          class="grow-0"
          mat-stroked-button
          type="button">
    <ng-container i18n>Cancel</ng-container>
  </button>
</mat-dialog-actions>
